module.exports = __webpack_public_path__ + "img/home_30.411633af.png";